import { IItem } from '@checkout/items';
import * as cx from 'classnames';
import * as React from 'react';
import { Fragment } from 'react';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { addLineItemRequest, removeLineItemRequest } from '../../../reducers/checkout';
import { isMediumDevice } from '../../../utils/utils';
import { IconButton, Price, ProductDetails, ProductImage, ProductName } from '../../presentational';
import * as Styles from './ProductItem.scss';

interface IOwnProps {
  item: IItem;
  increaseQuantity: typeof addLineItemRequest;
  decreaseQuantity: typeof removeLineItemRequest;
  readOnly?: boolean;
  isGiftWrapProduct?: boolean;
  urlPrefix?: string;
}

type Props = IOwnProps;

interface IOwnState {
  increaseCount: number;
  decreaseCount: number;
  isProductDetailsVisible: boolean;
  isMobile: boolean;
}

class ProductItem extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    increaseCount: 0,
    decreaseCount: 0,
    isProductDetailsVisible: false,
    isMobile: true
  };

  componentDidMount() {
    this.handleCheckDeviceSize();
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleCheckDeviceSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleCheckDeviceSize);
  }

  handleCheckDeviceSize = () => {
    this.setState({ isMobile: isMediumDevice() });
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      increaseCount: 0,
      decreaseCount: 0,
    });
  }

  increase = () => {
    let { increaseCount } = this.state;
    const { increaseQuantity: increase, item } = this.props;

    this.setState({
      increaseCount: ++increaseCount,
    });
    increase({ line: item.line, quantity: increaseCount });
  }

  decrease = () => {
    let { decreaseCount } = this.state;
    const { decreaseQuantity: decrease, item } = this.props;

    if (item.quantity >= decreaseCount) {
      this.setState({
        decreaseCount: ++decreaseCount,
      });
      decrease({ line: item.line, quantity: decreaseCount });
    }
  }

  remove = () => {
    const { decreaseQuantity: removeProduct, item } = this.props;
    removeProduct({ line: item.line, quantity: item.quantity });
  }

  toggleProductDetails = () => {
    const { isProductDetailsVisible } = this.state;

    this.setState({
      isProductDetailsVisible: !isProductDetailsVisible,
    });
  }

  render() {
    const { readOnly, item, isGiftWrapProduct, urlPrefix } = this.props;
    const { isProductDetailsVisible, isMobile } = this.state;
    const { product, quantity, line, priceEach, totalPrice, anyDiscount, priceEachBeforeDiscount, sku, size } = item;
    let uri = product && product.categoryUri ? `/${ product.categoryUri }/${ product.uri }` : `/${ product && product.uri }`;

    // Use url prefix if defined in contextCheckoutConfig.ts
    if (urlPrefix) {
      uri = `/${urlPrefix}${uri}`;
    }

    const itemClassNames = cx({
      [Styles.item]: true,
      [Styles.giftWrap]: isGiftWrapProduct,
    });

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <Fragment>
            <div className={itemClassNames} key={line}>
              {product && !readOnly && product.media && product.media.standard && (
                <div className={Styles.image}>
                  <ProductImage
                    onClick={checkoutContextConfig.ui.productItem.withProductDetails && !readOnly && isMobile ?
                      { action: this.toggleProductDetails } :
                      { uri }}
                    src={product.media.standard[0]}
                    alt={product.name}
                    isClickable={!isGiftWrapProduct}
                  />
                </div>
              )}
              <div className={Styles.details}>
                <div className={Styles.left}>
                  {product && (
                    <ProductName
                      onClick={checkoutContextConfig.ui.productItem.withProductDetails && !readOnly && isMobile ?
                        { action: this.toggleProductDetails } :
                        { uri }}
                      name={product.name}
                      isClickable={!isGiftWrapProduct}
                    />
                  )}
                  <div className={Styles.attributes}>
                    {checkoutContextConfig.ui.productItem.isSkuVisible && !isGiftWrapProduct && <div className={Styles.line}>{sku}</div>}
                    {product && product.variantName && checkoutContextConfig.ui.productItem.isVariantNameVisible &&
                    !isGiftWrapProduct && (
                      <div className={Styles.line}>{product.variantName}</div>
                    )}
                    {checkoutContextConfig.ui.productItem.isSizeVisible &&
                      !isGiftWrapProduct && <div className={Styles.line}>{size}</div>}
                  </div>
                  {!(checkoutContextConfig.ui.productItem.withProductDetails && !readOnly && isMobile) && !readOnly && !isGiftWrapProduct && (
                    <div className={Styles.buttons}>
                      <div className={Styles.quantity}>
                        <IconButton onClick={this.decrease} icon="minus" />
                        <span className={Styles.value}>{quantity}</span>
                        <IconButton onClick={this.increase} icon="plus" />
                      </div>
                      <div className={Styles.remove}>
                        <button type="button" className={Styles.removeButton} onClick={this.remove}>
                          Remove
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                <div className={Styles.right}>
                  <div className={Styles.price}>
                    <Price
                      quantity={quantity}
                      anyDiscount={anyDiscount}
                      priceEach={priceEach}
                      totalPrice={totalPrice}
                      priceEachBeforeDiscount={priceEachBeforeDiscount}
                    />
                  </div>
                  {product && product.klarna_age_limit && product.klarna_age_limit === '18' && (
                    <span className={Styles.ageLimitLabel}>18 År</span>
                  )}
                </div>
              </div>
            </div>
            {checkoutContextConfig.ui.productItem.withProductDetails && isProductDetailsVisible && !readOnly && (
              <ProductDetails
                close={this.toggleProductDetails}
                increase={this.increase}
                decrease={this.decrease}
                removeProduct={this.remove}
                quantity={quantity}
                item={item}
              />
            )}
          </Fragment>
        ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default ProductItem;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/ProductItem/ProductItem.tsx